import {
  $1,
  getJSON,
  addEvent,
  empty,
  createTree,
  append
} from 'fmjs';

const replaceStates = (states = {}, select) => {
  const optionTree = Object.entries(states)
  .sort((a, b) => {
    return a[0] - b[0];
  })
  .map(([value, text]) => {
    return {tag: 'option', value, text};
  });

  if (optionTree.length > 1) {
    optionTree.unshift({tag: 'option', value: '', text: 'Choose one…'});
  }

  empty(select);

  const options = createTree({children: optionTree});

  append(select, options);
};

const updateStates = ({states, fieldset, country}) => {
  const stateSelect = $1('.js-stateSelect', fieldset);
  const countryId = country.value;

  if (!countryId || !stateSelect) {
    return;
  }
  if (states.hasOwnProperty(countryId)) {
    replaceStates(states[countryId], stateSelect);
  }
};

const getStates = async() => {
  let states = {};

  try {
    const {response} = await getJSON('/actions/appmodule/commerce/get-states-as-list');

    states = response;
  } catch (err) {
    return console.error(err);
  }

  // Apply state-updating code to both the shipping-address fields and the billing-address fields
  ['shipping-address', 'billing-address']
  .map((id) => document.getElementById(id))
  .filter((el) => !!el)
  .forEach((fieldset) => {
    const country = $1('.js-addressCountry', fieldset);

    addEvent(country, 'change', () => {
      updateStates({states, fieldset, country});
    });
  });


};

export const init = getStates;
